import React, { useEffect, useRef } from 'react';

interface AdBannerProps {
  size: 'leaderboard' | 'skyscraper' | 'responsive' | 'native';
  className?: string;
}

const AdBanner: React.FC<AdBannerProps> = ({ size, className = '' }) => {
  const adRef = useRef<HTMLDivElement>(null);
  
  useEffect(() => {
    // Load ads when component mounts
    try {
      if (window.adsbygoogle && adRef.current) {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      }
    } catch (error) {
      console.error('AdSense error:', error);
    }
  }, []);

  const getAdDimensions = () => {
    switch (size) {
      case 'leaderboard':
        return 'h-24 md:h-20'; // 728x90
      case 'skyscraper':
        return 'w-80 h-96'; // 300x600
      case 'responsive':
        return 'h-32 md:h-24';
      case 'native':
        return 'h-40';
      default:
        return 'h-24';
    }
  };

  return (
    <div className={`${getAdDimensions()} ${className}`}>
      <ins 
        className="adsbygoogle"
        style={{ display: 'block' }}
        data-ad-client="ca-pub-7434679080730077"
        data-ad-slot="6624710912"
        data-ad-format="auto"
        data-full-width-responsive="true"
        ref={adRef}
      />
    </div>
  );
};

export default AdBanner;